import { BILLING_EMBED_PATH } from '../constants';

const replaceBillingEmbedPath = (path: URL['pathname']): string =>
	path.replace('/billing', BILLING_EMBED_PATH);

export function convertToSameOrigin(originalUrl: string): URL {
	// The original URL is expected to be an absolute URL with the AdminHub origin
	const urlWithAdminhubOrigin = new URL(originalUrl);

	// We convert the URL to the same origin as the current window, with the correct pathname for adminhub billing embed
	const url = new URL(
		window.location.origin + replaceBillingEmbedPath(urlWithAdminhubOrigin.pathname),
	);

	url.search = urlWithAdminhubOrigin.search;
	url.hash = urlWithAdminhubOrigin.hash;

	return url;
}
